import {
  batteryApiErrorMessage,
  isRefreshPaymentRequiredError,
} from "~/api/battery-financing-errors"
import { queryKeys } from "~/api/cache"
import useBatteryLightReachApplicationDisclosures from "~/api/hooks/useBatteryLightReachApplicationDisclosures"
import useBatteryLightReachContract from "~/api/hooks/useBatteryLightReachContract"
import useSubmitBatteryLightReachApplication from "~/api/hooks/useSubmitBatteryLightReachApplication"

import type { LightReachApplicationBundle } from "../../../ProposalSetup/financing/lightreach/lightreach-kind-bundle"

/** Battery-Only Proposal commands for the shared LightReach application pieces. */
export const batteryLightReachApplicationBundle: LightReachApplicationBundle = {
  testIdPrefix: `battery`,
  financingQueryKey: queryKeys.batteryProposal.financing,
  useDisclosures: useBatteryLightReachApplicationDisclosures,
  useSubmit: useSubmitBatteryLightReachApplication,
  useContract: useBatteryLightReachContract,
  isRefreshRequiredError: isRefreshPaymentRequiredError,
  errorMessage: batteryApiErrorMessage,
}
